import { makeObservable, observable } from "mobx";

/**
 * 查询条件和排序条件的基类
 */
export class Expression {
  // 是否激活的
  activated: boolean;
  // 是否可见
  visible: boolean;
  // meta 信息
  meta: any;
  constructor(activated = true, visible = true, meta: any) {
    this.activated = activated;
    this.visible = visible;
    this.meta = meta;
    makeObservable(this, {
      activated: observable,
      visible: observable,
      meta: observable
    });
  }

  /**
   * 设置显示隐藏
   * @param a visible boolean
   */
  setVisible(v: boolean) {
    this.visible = v;
  }

  /**
   * 获取 getVisible
   * @returns 返回 visible
   */
  getVisible() {
    return this.visible;
  }

  /**
   * 设置激活状态
   * @param a activated boolean
   */
  setActivated(a: boolean) {
    this.activated = a;
  }

  /**
   * 获取 getActivated
   * @returns 返回 activated
   */
  getActivated() {
    return this.activated;
  }

  setMeta(meta: any) {
    this.meta = meta;
  }

  getMeta() {
    return this.meta;
  }
}
